var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06839 3.82264C7.14688 3.74697 7.27152 3.74811 7.34861 3.8252L10.4133 6.88985C10.4924 6.96897 10.4912 7.0976 10.4106 7.17526L5.74157 11.6762C5.7043 11.7121 5.65454 11.7322 5.60277 11.7322H2.53594C2.42548 11.7322 2.33594 11.6426 2.33594 11.5322V8.46963C2.33594 8.41532 2.35803 8.36334 2.39713 8.32564L7.06839 3.82264ZM7.34779 5.52751C7.27102 5.45074 7.14703 5.44924 7.06842 5.52412L3.57257 8.85408C3.53294 8.89183 3.51051 8.94417 3.51051 8.9989V10.3576C3.51051 10.4681 3.60005 10.5576 3.71051 10.5576H5.0749C5.12627 10.5576 5.17566 10.5378 5.21285 10.5024L8.70579 7.17522C8.78715 7.09773 8.78872 6.96844 8.70927 6.88899L7.34779 5.52751ZM8.90457 2.13464C8.98375 2.05986 9.10823 2.06219 9.18456 2.13988L12.197 5.20612C12.2739 5.28442 12.2734 5.41009 12.1958 5.48771L11.479 6.2045C11.4009 6.28261 11.2742 6.28261 11.1961 6.2045L8.13553 3.14391C8.05585 3.06422 8.0577 2.93446 8.13963 2.85708L8.90457 2.13464Z",
    fill: "#FD9E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCommentIcon);
export default __webpack_public_path__ + "static/media/account-comment-icon.26b484d85f79e44f7f1c22ac2ebaf6f8.svg";
export { ForwardRef as ReactComponent };